<template>
  <el-popover ref="managerDown" placement="bottom" width="284" trigger="click" :disabled="disabled">
    <div class="my-dropdown2">
      <el-input v-model="keyword" placeholder="输入成员名称">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-scrollbar style="max-height:360px" :native="false" :noresize="true" tag="ul">
        <div v-for="item in showList" :key="item.uid" class="flex down-item pr pl pt-sm pb-sm  mt-sm"
          @click="handleChange(item)">
          <span class="bd flex align-items-center">
            <f-user-avatar :user="item" :preview="false" size="mini" role="button" />
            <span class="ml-xs ellipsis">{{ item.username }}</span>
          </span>
          <div v-if="uid==item.uid" class="ft flex-center">
            <i class="el-icon-check text-primary"></i>
          </div>
        </div>
      </el-scrollbar>

    </div>
    <slot slot="reference" ></slot>
  </el-popover>
</template>

<script>
import store from "@/store/store"

export default {
  props: {
    uid: {
      type: [Number, String, Object, null]
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      keyword: '',
    }
  },
  computed: {
    showList () {
      return store.state.middleStore.TeamMember.length ? store.state.middleStore.TeamMember.filter(item => {
        return item.username.match(this.keyword)
      }) : []
    },
    tmpUser () {
      return store.state.middleStore.TeamMember.find(item => {
        return item.uid == store.state.userStore.user.uid
      })
    },
    user () {
      return store.state.userStore.user
    },
    proDetail () {
      return store.state.middleStore.proDetail
    }

  },

  created () {

  },
  mounted () {


  },
  methods: {
    handleChange (item) {
      if (this.uid == this.tmpUser.uid || this.tmpUser.uid == this.proDetail.principal || this.tmpUser.permission < 2) {
        this.$emit('change', item)
      } else {
        this.$message.error('无权限！')
      }
      this.$refs.managerDown.handleDocumentClick({ target: null })
    }
  }
}
</script>

<style lang="scss" scoped>
.my-dropdown2 {
  width: 260px;
  overflow-y: auto;

  .down-item {
    padding: 10px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background-color: rgba(153, 153, 153, 0.2);
    }
  }
}
</style>